interface BillingDate {
  day: string;
  month: string;
}

interface Args {
  hasInstallments: boolean;
  billingDate: BillingDate | null;
}

export const getLearnMoreWithScheduleDisplayState = ({
  hasInstallments,
  billingDate,
}: Args) => {
  const shouldUsePayLaterHeader = Boolean(billingDate) && !hasInstallments;

  return {
    shouldUsePayLaterHeader,
    shouldRenderInstallmentsSchedule: !shouldUsePayLaterHeader,
  };
};
